import { Canvas } from '@react-three/fiber';
import { SpinGallery } from '../components/gallery/SpinGallery';
import { ProjectDetails } from '../components/gallery/ProjectDetails';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { ScrollHelper, ClickHelper } from '../components/ui/Helpers';
import { useResize } from '../hooks/viewport/useResize';
import { CAMERA_CONFIG } from '../constants/config';
import { projects } from '../data/projects';
import { useState, useEffect } from 'react';
import { ProjectIndicator } from '../components/ui/ProjectIndicator';
import { useAppStore } from '../store/useAppStore';

interface HomeProps {
  allMediaLoaded: boolean;
}

export const Home: React.FC<HomeProps> = ({ allMediaLoaded }) => {
  const { width, height } = useResize();
  const [showGallery, setShowGallery] = useState(false);
  const selectedProject = useAppStore(state => state.selectedProject);
  const isMobile = window.innerWidth < 768;
  const showHeaderFooter = !selectedProject || !isMobile;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGallery(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative w-full h-full">
      <div className="fixed inset-0 w-full h-full overflow-hidden">
        {showHeaderFooter && (
          <>
            <Header />
            <Footer />
          </>
        )}
        <ProjectDetails />
        <Canvas
          camera={CAMERA_CONFIG}
          className="w-full h-full bg-[#f7f7f7]"
          style={{
            width,
            height,
          }}
          gl={{
            antialias: true,
            alpha: true,
            powerPreference: 'high-performance',
            stencil: false,
            depth: true,
            // @ts-ignore - samples is a valid WebGL parameter but not typed in R3F
            samples: 4,
          }}
        >
          <ambientLight intensity={0.5} />
          <pointLight position={[10, 10, 10]} />
          {showGallery && (
            <SpinGallery projects={projects} allMediaLoaded={allMediaLoaded} />
          )}
        </Canvas>
      </div>
      <ProjectIndicator projects={projects} />
      <ScrollHelper />
      <ClickHelper />
    </div>
  );
};
